import React, { useState, useEffect, Fragment } from 'react';
import { Table } from 'reactstrap'
import FileSaver from 'file-saver'
import styled from 'styled-components';
import { Block } from '../../styles/commons'
import Portal from '../../stacks//portal/PortalAWS'
import {useErrorToast} from '../../hooks/useErrorToast';

const DownloadFiles = props => {
  const {setErrorMsg, errorToast} = useErrorToast('');
  const [, setLoading] = useState(false);
  const [fileList, setFileList] = useState([])

  const {companyId} = props

  useEffect(() => {
    async function getList() {
      try {
        const api = Portal.getInstance()
        const list = await api.listFileUpload(companyId)
        setFileList(list)
        setLoading(false)
      }
      catch (err) {
        setErrorMsg(err.message)
        setLoading(false)
        }
    }

    getList()
  }, [companyId, setErrorMsg])

  async function saveFile(url, fileName) {
    try {
      FileSaver.saveAs(url, fileName)
    }
    catch (err) {
      console.error(`saveFile ${err.message} ${err.stack}`)
    }
  }
  async function downloadFile(fileName, only) {
    try {
      setErrorMsg('')
      setLoading(true)
      const api = Portal.getInstance()
      const url = await api.retrieveFileDownloadURL(companyId, fileName, only ? `attachment; filename="${fileName}"` : undefined)
      // FileSaver.saveAs(url, fileName)
      await saveFile(url, fileName)
      setLoading(false)
    }
    catch (err) {
      setErrorMsg(err.message)
      setLoading(false)
      console.error(`ERROR downloadFile ${err.message}`)
    }
  }

  return (
    <Fragment>
      <Block>
        <Table striped size="small">
          <thead>
            <tr><th>Download</th><th>Upload Time</th><th>Size</th></tr>
          </thead>
          <tbody>
            {
              fileList.map((item) => {
                const dateTime = new Date(item.lastModified)
                return (
                  <tr key={item.fileName}>
                    <td><Download onClick={() => {downloadFile(item.fileName, true)} }>{item.title}</Download></td>
                    <td>{dateTime.toLocaleString()}</td>
                    <td>{item.size}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </Table>
        </Block>
      {errorToast}
    </Fragment>
  )
}

const Download = styled.span`
  text-decoration: underline;
  :hover {
    background: lightGrey;
  }
`
export default DownloadFiles
